import { action } from 'typesafe-actions';

import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { IKnmPlanFilter } from 'PlanListPackage/PlanListFiltersModule/interfaces/IKnmPlanFilter';

import { KnmPlanListFilterActionsEnum } from '../enums/KnmPlanListFilterActionsEnum';

export interface IPlanListFilterSetCurrentParams {
  current?: IKnmPlanFilter;
  currentId?: IFilterResult['id'];
}

export const planListFilterSetLoading = (value: boolean) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_LOADING, { value });
export const planListFilterSetSwitcher = (value: boolean) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_SWITCHER, { value });
export const planListFilterSetCurrent = ({ current, currentId }: IPlanListFilterSetCurrentParams) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_CURRENT, { current, currentId });
export const planListFilterGetMeta = () => action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_GET_META);
export const planListFilterSetMeta = (list: IFilterResult[]) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_META, { list });
export const planListFilterGetData = (id: IFilterResult['id']) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_GET_DATA, { id });
export const planListFilterSetData = (id: IFilterResult['id'], data: IKnmPlanFilter) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_DATA, { id, data });
export const planListFilterCreate = (data: IKnmPlanFilter) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_CREATE, { data });
export const planListFilterUpdate = (id: IFilterResult['id'], data: IKnmPlanFilter) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_UPDATE, { id, data });
export const planListFilterRemove = (id: IFilterResult['id']) =>
  action(KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_REMOVE, { id });
